/**
 * Application role identifiers for RBAC.
 * Align with auth userTypes: frontDesk -> FRONT_DESK, doctor -> DOCTOR, nurse -> NURSE, biller -> BILLER.
 * ADMINISTRATOR is reserved for users with isAdministrator true / roleName ADMINISTRATOR (full access).
 */
export const AppRole = {
  FRONT_DESK: 'FRONT_DESK',
  NURSE: 'NURSE',
  DOCTOR: 'DOCTOR',
  BILLER: 'BILLER',
  ADMINISTRATOR: 'ADMINISTRATOR',
} as const;

export type AppRoleType = (typeof AppRole)[keyof typeof AppRole];

/** Role display labels */
export const APP_ROLE_LABELS: Record<AppRoleType, string> = {
  [AppRole.FRONT_DESK]: 'Front Desk',
  [AppRole.NURSE]: 'Nurse',
  [AppRole.DOCTOR]: 'Doctor',
  [AppRole.BILLER]: 'Biller',
  [AppRole.ADMINISTRATOR]: 'Administrator',
};
